module.exports = __webpack_public_path__ + "img/logo.5ff1fed5.png";